const WoundsInjuries = (props: { fill: string }) => (
	<path
		transform="scale(0.0333) translate(0, 960)"
		d="m136-80-56-56 88-88-88-24 21-77 87 24-23-88 77-21 24 88 137-137-88-24 21-77 87 23-23-87 77-21 24 88 137-137-88-24 21-77 88 23-24-87 77-21 24 88 88-88 56 56-88 88 88 24-21 77-87-24 23 88-77 21-24-88-137 137 88 24-21 77-87-23 23 87-77 21-24-88-137 137 88 24-21 77-88-23 24 87-77 21-24-88-88 88Z"
		fill={props.fill}
	/>
);

export default WoundsInjuries;
